<!-- Client Management Modal -->
<div class="modal-backdrop fade show" *ngIf="showModal"
     style="z-index: 1055 !important;"
     (click)="close()"></div>

<div class="modal fade show d-block" *ngIf="showModal"
     style="z-index: 1056 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Client Management</h5>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Search Bar and Add Button -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="input-group" style="max-width: 300px;">
            <span class="input-group-text">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Search clients..."
              [(ngModel)]="searchTerm"
              (input)="filterClients()"
            />
          </div>
          <button class="btn btn-primary" (click)="openAddClientModal()">
            <i class="bi bi-plus-circle me-1"></i>Add Client
          </button>
        </div>

        <!-- Clients Table -->
        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Currency</th>
                <th>Default Markup %</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let client of filteredClients">
                <td><strong>{{ client.name }}</strong></td>
                <td><span class="badge bg-light text-dark">{{ getClientTypeLabel(client.clientType) }}</span></td>
                <td>{{ client.defaultCurrency }}</td>
                <td>{{ client.defaultMarkupPercentage }}%</td>
                <td>
                  <span class="badge bg-success" *ngIf="client.isActive">Active</span>
                  <span class="badge bg-secondary" *ngIf="!client.isActive">Inactive</span>
                </td>
                <td>
                  <button class="btn btn-sm btn-link p-1" (click)="openEditClientModal(client)" title="Edit">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-link text-danger p-1" (click)="deleteClient(client.id)" title="Delete">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredClients.length === 0">
                <td colspan="6" class="text-center text-muted py-4">
                  <i class="bi bi-inbox me-2"></i>No clients found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Add Client Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showAddModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeAddClientModal()"></div>

<div class="modal fade show d-block" *ngIf="showAddModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Add Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Add New Client</h5>
        <button type="button" class="btn-close" (click)="closeAddClientModal()"></button>
      </div>

      <!-- Add Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Client Name + Type -->
          <div class="row mb-3">
            <div class="col-md-8">
              <label for="addClientName" class="form-label">Client Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="addClientName"
                [(ngModel)]="formData.name"
                name="name"
                placeholder="Enter client name"
                required
              />
            </div>
            <div class="col-md-4">
              <label for="addClientType" class="form-label">Client Type</label>
              <select class="form-select" id="addClientType" [(ngModel)]="formData.clientType" name="clientType">
                <option [ngValue]="undefined">-- Select --</option>
                <option *ngFor="let t of clientTypes" [ngValue]="t.value">{{ t.label }}</option>
              </select>
            </div>
          </div>

          <!-- Default Currency -->
          <div class="mb-3">
            <label for="addCurrency" class="form-label">Default Currency</label>
            <select
              class="form-select"
              id="addCurrency"
              [(ngModel)]="formData.defaultCurrency"
              name="defaultCurrency">
              <option *ngFor="let currency of availableCurrencies" [value]="currency">
                {{ currency }}
              </option>
            </select>
          </div>

          <!-- Default Markup % -->
          <div class="mb-3">
            <label for="addMarkup" class="form-label">Default Markup %</label>
            <input
              type="number"
              class="form-control"
              id="addMarkup"
              [(ngModel)]="formData.defaultMarkupPercentage"
              name="defaultMarkupPercentage"
              min="0"
              max="100"
              step="0.01"
              placeholder="0.00"
            />
          </div>

          <!-- Active Toggle -->
          <div class="mb-3">
            <label class="form-label d-block">Status</label>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="addClientActive"
                [(ngModel)]="formData.isActive"
                name="isActive"
              />
              <label class="form-check-label" for="addClientActive">
                Active
              </label>
            </div>
          </div>
        </form>
      </div>

      <!-- Add Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddClientModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createClient()">Create</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Client Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showEditModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeEditClientModal()"></div>

<div class="modal fade show d-block" *ngIf="showEditModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Edit Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Edit Client</h5>
        <button type="button" class="btn-close" (click)="closeEditClientModal()"></button>
      </div>

      <!-- Edit Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Client Name + Type -->
          <div class="row mb-3">
            <div class="col-md-8">
              <label for="editClientName" class="form-label">Client Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="editClientName"
                [(ngModel)]="editFormData.name"
                name="editName"
                required
              />
            </div>
            <div class="col-md-4">
              <label for="editClientType" class="form-label">Client Type</label>
              <select class="form-select" id="editClientType" [(ngModel)]="editFormData.clientType" name="editClientType">
                <option [ngValue]="undefined">-- Select --</option>
                <option *ngFor="let t of clientTypes" [ngValue]="t.value">{{ t.label }}</option>
              </select>
            </div>
          </div>

          <!-- Default Currency -->
          <div class="mb-3">
            <label for="editCurrency" class="form-label">Default Currency</label>
            <select
              class="form-select"
              id="editCurrency"
              [(ngModel)]="editFormData.defaultCurrency"
              name="editDefaultCurrency">
              <option *ngFor="let currency of availableCurrencies" [value]="currency">
                {{ currency }}
              </option>
            </select>
          </div>

          <!-- Default Markup % -->
          <div class="mb-3">
            <label for="editMarkup" class="form-label">Default Markup %</label>
            <input
              type="number"
              class="form-control"
              id="editMarkup"
              [(ngModel)]="editFormData.defaultMarkupPercentage"
              name="editDefaultMarkupPercentage"
              min="0"
              max="100"
              step="0.01"
            />
          </div>

          <!-- Active Toggle -->
          <div class="mb-3">
            <label class="form-label d-block">Status</label>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="editClientActive"
                [(ngModel)]="editFormData.isActive"
                name="editIsActive"
              />
              <label class="form-check-label" for="editClientActive">
                Active
              </label>
            </div>
          </div>
        </form>
      </div>

      <!-- Edit Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeEditClientModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateClient()">Update</button>
      </div>
    </div>
  </div>
</div>
